import React from 'react';

const InstructionDisplay = () => {
    return (
        <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
            <h2>Select Your Desired Template for Completion</h2>
            <br></br>
            <p>If Deals Due Diligence:</p>
            <ul>
                <li>
                    In the three specific file upload buttons, upload OCR’d PDFs of the
                    latest company accounts, the previous year's company accounts, and
                    the latest scheme valuation.
                </li>
                <li>Upload any other relevant PDFs to the other upload section.</li>
                <li>Complete the User Inputs with the relevant information. The account years should correspond to the latest year, previous year, and 2 years ago account dates.</li>
                <li>The valuation date should refer to the date of the full scheme valuation.</li>
                <li>Click generate to populate the PowerPoint and Excel templates.</li>
                <li>Click download to download the completed files as desired.</li>
            </ul>
        </div>
    );
};

export default InstructionDisplay;
